<template>
    <div class="centerWidth">
        <div class="gaokao">
            <!-- <div class="gaokao-nav">
				<span>个人中心 ></span>
				<span>学生学情档案</span>
			</div> -->
            <section class="gaokao-content">
                <div class="my-title">学生学情档案</div>
                <article class="fenNum_head flex zhong center xieqDiv">
                    <p class="on">
                        <i></i>
                        <span>基本信息</span>
                    </p>
                    <p class="on">
                        <i></i>
                        <span>成绩信息</span>
                    </p>
                    <p>
                        <i></i>
                        <span>综合信息</span>
                    </p>
                    <p>
                        <i></i>
                        <span>偏爱方向</span>
                    </p>
                </article>
                <article class="grade-content">
                    <table
                        class="grade-table"
                        cellpadding="0"
                        cellspacing="0"
                        align="center"
                        rules="none"
                    >
                        <tr>
                            <th colspan="7">成绩信息</th>
                        </tr>
                        <tr>
                            <td rowspan="2">学科/学期</td>
                            <td>高一(上)期末</td>
                            <td>高一(下)期末</td>
                            <td>高二(上)期末</td>
                            <td>高二(下)期末</td>
                            <td>高三(上)期末</td>
                            <td>学业水平（会考）</td>
                        </tr>
                        <tr>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                        </tr>
                        <tr
                            v-for="(item, index) in listA"
                            :key="index"
                        >
                            <td>{{ item.subject }}</td>
                            <td>
                                <input v-model="item.oneUpper1" />
                                <span>/</span>
                                <input v-model="item.oneUpper2" />
                            </td>
                            <td>
                                <input v-model="item.oneUp1" />
                                <span>/</span>
                                <input v-model="item.oneUp2" />
                            </td>
                            <td>
                                <input v-model="item.twoUpper1" />
                                <span>/</span>
                                <input v-model="item.twoUpper2" />
                            </td>
                            <td>
                                <input v-model="item.twoUp1" />
                                <span>/</span>
                                <input v-model="item.twoUp2" />
                            </td>
                            <td>
                                <input v-model="item.threeUpper1" />
                                <span>/</span>
                                <input v-model="item.threeUpper2" />
                            </td>
                            <td>
                                <input v-model="item.threeUp1" />
                                <span>/</span>
                                <input v-model="item.threeUp2" />
                            </td>
                        </tr>
                    </table>

                    <table
                        class="grade-table"
                        cellpadding="0"
                        cellspacing="0"
                        align="center"
                        rules="none"
                    >
                        <tr>
                            <th colspan="4">模考成绩</th>
                        </tr>
                        <tr>
                            <td rowspan="2">学科/学期</td>
                            <td>高三第一次模考</td>
                            <td>高三第二次模考</td>
                            <td>高三第三次模考</td>
                        </tr>
                        <tr>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                        </tr>
                        <tr
                            v-for="(item, index) in listB"
                            :key="index"
                        >
                            <td>{{ item.subject }}</td>
                            <td>
                                <input v-model="item.first1" />
                                <span>/</span>
                                <input v-model="item.first2" />
                            </td>
                            <td>
                                <input v-model="item.second1" />
                                <span>/</span>
                                <input v-model="item.second2" />
                            </td>
                            <td>
                                <input v-model="item.third1" />
                                <span>/</span>
                                <input v-model="item.third2" />
                            </td>
                        </tr>
                    </table>

                    <table
                        class="grade-table"
                        cellpadding="0"
                        cellspacing="0"
                        align="center"
                        rules="none"
                    >
                        <tr>
                            <th colspan="12">单科排名</th>
                        </tr>
                        <tr>
                            <td rowspan="2">学科/学期</td>
                            <td>高一(上)期末</td>
                            <td>高一(下)期末</td>
                            <td>高二(上)期末</td>
                            <td>高二(下)期末</td>
                            <td>高三(上)期末</td>
                            <td>高三第一次模考</td>
                            <td>高三第二次模考</td>
                            <td>高三第三次模考</td>
                        </tr>
                        <tr>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                            <td>成绩/满分</td>
                        </tr>
                        <tr
                            v-for="(item, index) in listC"
                            :key="index"
                        >
                            <td>{{ item.subject }}</td>
                            <td>
                                <input v-model="item.oneUpper1" />
                                <span>/</span>
                                <input v-model="item.oneUpper2" />
                            </td>
                            <td>
                                <input v-model="item.oneUp1" />
                                <span>/</span>
                                <input v-model="item.oneUp2" />
                            </td>
                            <td>
                                <input v-model="item.twoUpper1" />
                                <span>/</span>
                                <input v-model="item.twoUpper2" />
                            </td>
                            <td>
                                <input v-model="item.twoUp1" />
                                <span>/</span>
                                <input v-model="item.twoUp2" />
                            </td>
                            <td>
                                <input v-model="item.threeUpper1" />
                                <span>/</span>
                                <input v-model="item.threeUpper2" />
                            </td>
                            <td>
                                <input v-model="item.first1" />
                                <span>/</span>
                                <input v-model="item.first2" />
                            </td>
                            <td>
                                <input v-model="item.second1" />
                                <span>/</span>
                                <input v-model="item.second2" />
                            </td>
                            <td>
                                <input v-model="item.third1" />
                                <span>/</span>
                                <input v-model="item.third2" />
                            </td>
                        </tr>
                    </table>
                </article>
                <div class="test-btn">
                    <button
                        class="gaokao-btn"
                        @click="goTesta()"
                    >上一步</button>
                    <button
                        class="gaokao-btn"
                        @click="goTestc()"
                    >下一步</button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
    data() {
        return {
            sid: 0,
            IsCke: true,
            listA: [
                {
                    subject: '语文',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '数学',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '外语',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '政治',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '历史',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '地理',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '物理',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '化学',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '生物',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '美术',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '体育',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '音乐',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '信息技术',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '通用技术',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '文科综合',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '理科综合',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '总分',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '年级排名',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                },
                {
                    subject: '年级人数',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    threeUp1: '',
                    threeUp2: ''
                }
            ],
            listB: [
                {
                    subject: '语文',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '数学',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '外语',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '政治',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '历史',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '地理',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '物理',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '化学',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '生物',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '美术',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '体育',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '音乐',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '信息技术',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '通用技术',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '文科综合',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '理科综合',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '总分',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '年级排名',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '年级人数',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                }
            ],
            listC: [
                {
                    subject: '语文',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '数学',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '外语',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '政治',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '历史',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '地理',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '物理',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '化学',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '生物',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },

                {
                    subject: '文科综合',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                },
                {
                    subject: '理科综合',
                    oneUpper1: '',
                    oneUpper2: '',
                    oneUp1: '',
                    oneUp2: '',
                    twoUpper1: '',
                    twoUpper2: '',
                    twoUp1: '',
                    twoUp2: '',
                    threeUpper1: '',
                    threeUpper2: '',
                    first1: '',
                    first2: '',
                    second1: '',
                    second2: '',
                    third1: '',
                    third2: ''
                }
            ]
        };
    },
    // 加载
    created() {
        var that = this;

        var sid = that.$route.query.sid;
        if (sid > 0) {
            console.log('有ID', sid);
            that.sid = sid;
            that.GetStudentsAchievementBySid();
        }
    },
    methods: {
        // 获取列表
        GetStudentsAchievementBySid: function () {
            var that = this;

            that.$api.HtppRequest(
                'SystemData/GetStudentsAchievementBySid?sid=' + that.sid,
                'GET',
                {},
                function (res) {
                    console.log('获取', res);

                    if (res.flag) {
                        var list1 = res.list1;
                        var list2 = res.list2;
                        var list3 = res.list3;

                        var listA = [];
                        if (list1.length > 0) {
                            list1.map(itme => {
                                var obj = {
                                    subject: itme.Subject,
                                    oneUpper1: itme.SeniorOneUpper.split('/')[0],
                                    oneUpper2: itme.SeniorOneUpper.split('/')[1],
                                    oneUp1: itme.SeniorOneUp.split('/')[0],
                                    oneUp2: itme.SeniorOneUp.split('/')[1],
                                    twoUpper1: itme.SeniorTwoUpper.split('/')[0],
                                    twoUpper2: itme.SeniorTwoUpper.split('/')[1],
                                    twoUp1: itme.SeniorTwoUp.split('/')[0],
                                    twoUp2: itme.SeniorTwoUp.split('/')[1],
                                    threeUpper1: itme.SeniorThreeUpper.split('/')[0],
                                    threeUpper2: itme.SeniorThreeUpper.split('/')[1],
                                    threeUp1: itme.Examination.split('/')[0],
                                    threeUp2: itme.Examination.split('/')[1]
                                };

                                listA.push(obj);
                            });
                            that.listA = listA;
                        }

                        var listB = [];
                        if (list2.length > 0) {
                            list2.map(itme => {
                                var obj = {
                                    subject: itme.Subject,
                                    first1: itme.FirstModel.split('/')[0],
                                    first2: itme.FirstModel.split('/')[1],
                                    second1: itme.SecondModel.split('/')[0],
                                    second2: itme.SecondModel.split('/')[1],
                                    third1: itme.ThirdModel.split('/')[0],
                                    third2: itme.ThirdModel.split('/')[1]
                                };

                                listB.push(obj);
                            });
                            that.listB = listB;
                        }

                        var listC = [];
                        if (list3.length > 0) {
                            list3.map(itme => {
                                var obj = {
                                    subject: itme.Subject,
                                    oneUpper1: itme.SeniorOneUpper.split('/')[0],
                                    oneUpper2: itme.SeniorOneUpper.split('/')[1],
                                    oneUp1: itme.SeniorOneUp.split('/')[0],
                                    oneUp2: itme.SeniorOneUp.split('/')[1],
                                    twoUpper1: itme.SeniorTwoUpper.split('/')[0],
                                    twoUpper2: itme.SeniorTwoUpper.split('/')[1],
                                    twoUp1: itme.SeniorTwoUp.split('/')[0],
                                    twoUp2: itme.SeniorTwoUp.split('/')[1],
                                    threeUpper1: itme.SeniorThreeUpper.split('/')[0],
                                    threeUpper2: itme.SeniorThreeUpper.split('/')[1],
                                    first1: itme.FirstModel.split('/')[0],
                                    first2: itme.FirstModel.split('/')[1],
                                    second1: itme.SecondModel.split('/')[0],
                                    second2: itme.SecondModel.split('/')[1],
                                    third1: itme.ThirdModel.split('/')[0],
                                    third2: itme.ThirdModel.split('/')[1]
                                };

                                listC.push(obj);
                            });
                            that.listC = listC;
                        }
                    }
                },
                function (err) {
                    console.log(err);
                }
            );
        },
        // 上一步
        goTesta() {
            this.$router.push({ path: '/file', query: { sid: this.sid } });
        },
        // 下一步
        goTestc() {
            var that = this;
            if (!that.IsCke) {
                return;
            }

            var listAJson = '';
            var listA = [];
            var islistA = true;
            that.listA.map(item => {
                // if (
                // 	item.oneUpper1 === '' ||
                // 	item.oneUpper2 === '' ||
                // 	item.oneUp1 === '' ||
                // 	item.oneUp2 === '' ||
                // 	item.twoUpper1 === '' ||
                // 	item.twoUpper2 === '' ||
                // 	item.twoUp1 === '' ||
                // 	item.twoUp2 === '' ||
                // 	item.threeUpper1 === '' ||
                // 	item.threeUpper2 === '' ||
                // 	item.threeUp1 === '' ||
                // 	item.threeUp2 === ''
                // ) {
                // 	islistA = false;
                // }

                var obj = {
                    SAR_Id: that.sid,
                    Subject: item.subject,
                    SeniorOneUpper: item.oneUpper1 + '/' + item.oneUpper2,
                    SeniorOneUp: item.oneUp1 + '/' + item.oneUp2,
                    SeniorTwoUpper: item.twoUpper1 + '/' + item.twoUpper2,
                    SeniorTwoUp: item.twoUp1 + '/' + item.twoUp2,
                    SeniorThreeUpper: item.threeUpper1 + '/' + item.threeUpper2,
                    Examination: item.threeUp1 + '/' + item.threeUp2
                };

                listA.push(obj);
            });
            listAJson = JSON.stringify(listA);

            // if (!islistA) {
            // 	that.$util.showError('请完善成绩信息');
            // 	return false;
            // }

            // B
            var listBJson = '';
            var listB = [];
            var islistB = true;
            that.listB.map(item => {
                // if (item.first1 === '' || item.first2 === '' || item.second1 === '' || item.second2 === '' || item.third1 === '' || item.third2 === '') {
                // 	islistB = false;
                // }
                var obj = {
                    SAR_Id: that.sid,
                    Subject: item.subject,
                    FirstModel: item.first1 + '/' + item.first2,
                    SecondModel: item.second1 + '/' + item.second2,
                    ThirdModel: item.third1 + '/' + item.third2
                };

                listB.push(obj);
            });
            listBJson = JSON.stringify(listB);

            // if (!islistB) {
            // 	that.$util.showError('请完善模考成绩');
            // 	return false;
            // }

            // C
            var listCJson = '';
            var listC = [];
            var islistC = true;
            that.listC.map(item => {
                // if (
                // 	item.oneUpper1 === '' ||
                // 	item.oneUpper2 === '' ||
                // 	item.oneUp1 === '' ||
                // 	item.oneUp2 === '' ||
                // 	item.twoUpper1 === '' ||
                // 	item.twoUpper2 === '' ||
                // 	item.twoUp1 === '' ||
                // 	item.twoUp2 === '' ||
                // 	item.threeUpper1 === '' ||
                // 	item.threeUpper2 === '' ||
                // 	item.first1 === '' ||
                // 	item.first2 === '' ||
                // 	item.second1 === '' ||
                // 	item.second2 === '' ||
                // 	item.third1 === '' ||
                // 	item.third2 === ''
                // ) {
                // 	islistC = false;
                // }
                var obj = {
                    SAR_Id: that.sid,
                    Subject: item.subject,
                    SeniorOneUpper: item.oneUpper1 + '/' + item.oneUpper2,
                    SeniorOneUp: item.oneUp1 + '/' + item.oneUp2,
                    SeniorTwoUpper: item.twoUpper1 + '/' + item.twoUpper2,
                    SeniorTwoUp: item.twoUp1 + '/' + item.twoUp2,
                    SeniorThreeUpper: item.threeUpper1 + '/' + item.threeUpper2,
                    FirstModel: item.first1 + '/' + item.first2,
                    SecondModel: item.second1 + '/' + item.second2,
                    ThirdModel: item.third1 + '/' + item.third2
                };

                listC.push(obj);
            });
            listCJson = JSON.stringify(listC);

            // if (!islistC) {
            // 	that.$util.showError('请完善单科排名');
            // 	return false;
            // }

            if (islistA && islistB && islistC) {
                that.IsCke = false;
                that.$api.HtppRequest(
                    'SystemData/AddStudentsAchievement',
                    'POST',
                    {
                        SAR_Id: that.sid,
                        AchievementList: listAJson,
                        ModelExaminationList: listBJson,
                        SubjectRankingList: listCJson
                    },
                    function (res) {
                        console.log('添加', res);
                        // 临时缓存
                        Cookies.set('listA', that.listA);
                        Cookies.set('listB', that.listB);
                        Cookies.set('listC', that.listC);

                        if (res.flag) {
                            that.$router.push({ path: '/general', query: { sid: that.sid } });
                        }
                        that.IsCke = true;
                    },
                    function (err) {
                        console.log(err);
                        that.IsCke = true;
                    }
                );
            }
        }
    }
};
</script>

<style scoped>
.gaokao {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.gaokao-nav {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
}
.gaokao-nav span {
    font-size: 15px;
    color: #333;
}
.gaokao-nav span:last-child {
    color: #333;
}
.fenNum_head {
    margin-top: 20px;
}
/* gaokao-content */
.gaokao-content {
    padding: 0 20px;
    width: 100%;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 25px;
}
/* grade-content */
.grade-content {
    width: 100%;
    height: auto;
    overflow: hidden;
    margin-top: 40px;
}
/* grade-table */
.grade-table {
    width: 100%;
    height: auto;
    overflow: hidden;
    border: 1px solid #eee;
    margin-bottom: 20px;
}
.grade-table:last-child {
    margin-bottom: 0px;
}
.grade-table tr th {
    background-color: #eaeaea;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #333;
}
.grade-table tr {
    width: 100%;
    border-bottom: 1px solid #eee;
}
.grade-table tr td {
    height: 58px;
    text-align: center;
    font-size: 15px;
    color: #333;
    border-right: 1px solid #eee;
}
.grade-table tr td input {
    width: 40px;
    height: 30px;
    line-height: 30px;
    padding: 0 5px;
    border: 1px solid #eee;
    font-size: 15px;
    color: #333;
}
.grade-table tr td span {
    font-size: 15px;
    color: #333;
    padding: 0 10px;
}
.test-btn {
    display: flex;
    align-items: center;
    justify-content: center;
}
.test-btn button {
    margin-left: 20px;
    margin-right: 20px;
}
.gaokao-btn {
    width: 200px;
    height: 40px;
    background-color: #333;
    border-radius: 6px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    margin: 50px auto;
    display: block;
}
</style>
